import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import client from "../lib/api";
import { loadAnalytics } from "../lib/tracking";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("dic_consent");
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
    if (consent === "accepted") {
      client.get("/settings/public").then((r) => loadAnalytics(r.data.ga4_id, r.data.meta_pixel_id)).catch(() => {});
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem("dic_consent", value);
    setVisible(false);
    if (value === "accepted") {
      client.get("/settings/public").then((r) => loadAnalytics(r.data.ga4_id, r.data.meta_pixel_id)).catch(() => {});
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:left-6 sm:max-w-md z-[60] rounded-2xl bg-nero text-panna p-6 shadow-2xl border border-oro/20"
        >
          <p className="text-sm leading-relaxed text-panna/85">
            Questo sito usa cookie tecnici e, con il tuo consenso, cookie di misurazione per migliorare l'esperienza.
            Leggi la <a href="/cookie-policy" className="text-oro underline">Cookie Policy</a>.
          </p>
          <div className="flex gap-3 mt-5">
            <button data-testid="cookie-accept" onClick={() => choose("accepted")}
                    className="flex-1 rounded-full bg-bordeaux px-4 py-2.5 text-sm font-medium hover:bg-bordeaux-dark transition-colors">
              Accetta
            </button>
            <button data-testid="cookie-reject" onClick={() => choose("rejected")}
                    className="flex-1 rounded-full border border-panna/30 px-4 py-2.5 text-sm hover:border-oro hover:text-oro transition-colors">
              Rifiuta
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
